import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';

import Input from '@common/components/input/input';

import userInterfaceStore from '@store/user-interface';

import CheckEmailSC from './check-email.styled';
import { initialValues, validation } from './check-email.schema';
import { InputError } from '@common/components/input';
import providerApi from '@utils/api';
import StepButtons from '@components/step-buttons/step-buttons';
import { useIntl } from 'react-intl';

const CheckEmail = () => {
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const { formatMessage } = useIntl();

  const { values, errors, touched, handleBlur, handleChange, submitForm } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validation,
      onSubmit: async (values) => {
        setBtnLoading(true);
        const result = await providerApi.custom('/lead/create-verification', {
          method: 'POST',
          data: {
            email: values.email,
          },
        });

        dispatch(
          userInterfaceStore.initUserForm({
            email: values.email,
            leadToken: result.data.leadToken,
          }),
        );
        setBtnLoading(false);
        dispatch(userInterfaceStore.moveToNextStep());
      },
    });

  useEffect(() => {
    dispatch(
      userInterfaceStore.setNextStepDisabled({
        disabled: btnLoading || Object.keys(errors).length > 0,
      }),
    );
  }, [btnLoading, dispatch, errors]);

  return (
    <CheckEmailSC>
      <div className={'header'}>
        <h4>Zadajte váš e-mail</h4>
      </div>
      <div className={'content'}>
        <label htmlFor="email">E-mail</label>
        <Input
          id="email"
          name="email"
          type="email"
          variation="round"
          placeholder="@"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          hasError={Boolean(errors.email && touched.email)}
        />
        {errors.email && touched.email ? (
          <InputError error={errors.email} />
        ) : null}
        <span className="description">
          Zadajte vašu e-mailovú adresu, aby sme mohli overiť vašu identitu.
        </span>
      </div>
      <div className={'footer'}>
        <StepButtons
          renderNextBtn={true}
          handleNextClick={submitForm}
          handlePrevClick={() => {
            dispatch(
              userInterfaceStore.setNextStepDisabled({ disabled: false }),
            );
            dispatch(userInterfaceStore.moveToPrevStep());
          }}
          nextBtnLabel={formatMessage({ id: 'buttons.send' })}
        />
      </div>
    </CheckEmailSC>
  );
};

export default CheckEmail;
